import type { ParsedUrlQuery } from 'querystring';

import type { GetStaticProps, PreviewData } from 'next';

import {
  getRuntimeConfig,
  getRuntimeConfigPageProps,
  type PublicRuntimeConfig,
  type RuntimeConfigPageProps,
  useRuntimeConfig,
  withRuntimeConfigServerSideProps,
} from '@catawiki/next-config/runtime-config';

export type PagesRuntimeConfig = PublicRuntimeConfig;
export type PagesRuntimeConfigPageProps = RuntimeConfigPageProps;

export const getPagesRuntimeConfigPageProps = getRuntimeConfigPageProps;
export const getPagesRuntimeConfig = getRuntimeConfig;
export const usePagesRuntimeConfig = useRuntimeConfig;
export const withPagesRuntimeConfigServerSideProps =
  withRuntimeConfigServerSideProps;

function hasProps<P extends object>(
  result: Awaited<ReturnType<GetStaticProps<P>>>
): result is { props: P; revalidate?: number | boolean } {
  return 'props' in result;
}

export function withPagesRuntimeConfigStaticProps<
  P extends object,
  Params extends ParsedUrlQuery = ParsedUrlQuery,
  Preview extends PreviewData = PreviewData,
>(
  getStaticProps: GetStaticProps<P, Params, Preview>
): GetStaticProps<P & PagesRuntimeConfigPageProps, Params, Preview> {
  return async (context) => {
    const result = await getStaticProps(context);

    if (!hasProps(result)) {
      return result;
    }

    return {
      ...result,
      props: {
        ...result.props,
        ...getPagesRuntimeConfigPageProps(),
      },
    };
  };
}
